import { type FC } from "react";
import { Tag } from "lucide-react";

interface EstateExpensePillProps {
  onLearnMore: () => void;
}

export const EstateExpensePill: FC<EstateExpensePillProps> = ({ onLearnMore }) => {
  return (
    <button
      type="button"
      onClick={onLearnMore}
      className="group flex items-center gap-2 rounded-full bg-brand-subtle px-4 py-2 text-left text-sm"
    >
      <Tag className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" />
      <span>
        <span className="text-primary">Pay from the estate, or get reimbursed by it.</span>{" "}
        <span className="text-secondary">Elayne is an eligible estate expense.</span>
      </span>
      <span className="shrink-0 whitespace-nowrap font-medium text-brand underline group-hover:no-underline">
        Learn more
      </span>
    </button>
  );
};
